import { Control } from ".";

export class Divider extends Control {
    public getComponentName(): string {
        return "DividerComponent";
    }
}
